// Business info + service area — single source of truth.
// Change here to update the entire site.

export const BUSINESS = {
  name: "Magic Genie Services",
  brandLine: "Regina's premium cleaning company",
  phone: "236 506 9800",
  phoneHref: "tel:+12365069800",
  email: "info@magicgenieservices.ca",
  emailHref: "mailto:info@magicgenieservices.ca",
  serviceArea: {
    city: "Regina",
    region: "Saskatchewan",
    regionCode: "SK",
    country: "Canada",
    display: "Regina, Saskatchewan",
  },
  hours: {
    weekdays: "Mon to Fri · 8:00 AM to 6:00 PM",
    weekend:  "Sat · 9:00 AM to 4:00 PM",
    sunday:   "Sun · Closed",
  },
  social: {},
  siteUrl: "https://magicgenieservices.ca",
};
